import {
  usePrescriptionQuery,
  getDataPatientConsulta,
} from '@/hooks/queries/usePrescriptionQuery'
import { Text, Flex, useDisclosure, Icon } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { MdError } from 'react-icons/md'
import { PrescriptionModal } from './Modals/PrescriptionModal'
import { PostPrescription } from './Api/PostPrescription'

export function Prescription({ expand }: any) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { data: infos, refetch, isError, isLoading } = usePrescriptionQuery()
  const [url, setUrl] = useState()
  const userData = getDataPatientConsulta()

  useEffect(() => {
    setUrl(infos?.ModalURL)
  }, [infos])

  // useEffect(() => console.log(isLoading));

  useEffect(() => {
    // console.log(url);
    window.addEventListener(
      'message',
      event => {
        // console.log(event.data.type);
        PostPrescription(event.data, userData)
        const validEvents = ['cancel', 'excluded', 'prescricao']
        if (validEvents.includes(event.data.type)) {
          if (event.data.type === 'prescricao') {
            onOpen()
          }
        }
      },
      false,
    )
  }, [userData])

  return (
    <Flex p="20px" direction="column" flex="1">
      {!isError ? (
        <Flex
          w="100%"
          h="100%"
          bg="gray.200"
          align="center"
          justify="center"
          flex="1"
          display="block"
          position="relative"
        >
          <iframe
            height={expand === 4 ? '700px' : '500px'}
            width="100%"
            id="idframe"
            src={url}
            title="prescriçao"
            style={{
              zIndex: 99,
            }}
          />

          {isOpen ? (
            <PrescriptionModal
              isOpen={isOpen}
              onClose={onClose}
              refetch={refetch}
              isLoading={isLoading}
            />
          ) : null}
        </Flex>
      ) : (
        <Flex
          w="100%"
          align="center"
          justifyContent="center"
          flexDirection="column"
          border="1px solid #999999"
          padding={10}
        >
          <Icon
            as={MdError}
            cursor="pointer"
            color="brand-dark.200"
            fontSize={200}
            fontWeight="400"
            marginRight="15"
          />
          <Text
            fontSize="2xl"
            w="100%"
            color="brand-dark.300"
            fontFamily="Rubik"
            paddingBottom="19"
            align="center"
          >
            ERRO NA CONEXÃO COM A MEVO. TENTE NOVAMENTE MAIS TARDE.
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
